export const DEFAULT_SEARCH_TERM = "";

export const DEFAULT_SEARCH_DELAY = 800;
